module.exports = __webpack_public_path__ + "static/media/paperclip.c680dd4e.svg";